import { useAuthGuard } from '../hooks/useAuthGuard';
import { DeviceAuthContext } from '../providers/DeviceAuthContextProvider';
export var DeviceAuthGuard = function (_a) {
    var loader = _a.loader, redirectTo = _a.redirectTo, children = _a.children;
    return useAuthGuard({ context: DeviceAuthContext, loader: loader, redirectTo: redirectTo, children: children });
};
